import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconBulbFilled$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconBulbFilled extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '450bd917e5b47818e4e2b83c104b761647f05665', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'a70eecd13572abf7a0379c360fac486dfa097b1e', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '36207a3e9d6bcc138f75d56d6611632381196487', d: "M9 19.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V19H9z", fill: "currentColor" }), h("path", { key: '722750ed1e2508b7647dce1090493f3b1a110976', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.472 14.16C16.236 13.124 17 12.09 17 10.317 17 6.773 13.944 5 11.5 5S6 6.773 6 10.318c0 1.773.764 2.807 1.528 3.841.689.933 1.378 1.865 1.506 3.34a.537.537 0 0 0 .521.501h3.89a.537.537 0 0 0 .52-.501c.13-1.475.818-2.407 1.507-3.34m-3.222-3.41v5.75h-1.5v-5.75a.75.75 0 0 1 1.5 0", fill: "currentColor" }), h("path", { key: '659b3d40f27920a7855a64f60a2e943647d9edc6', d: "M11.5 1a.75.75 0 0 0-.75.75v.5a.75.75 0 0 0 1.5 0v-.5A.75.75 0 0 0 11.5 1M21 9.75a.75.75 0 0 0-.75-.75h-.5a.75.75 0 0 0 0 1.5h.5a.75.75 0 0 0 .75-.75M3.25 9a.75.75 0 0 1 0 1.5h-.5a.75.75 0 0 1 0-1.5zm2.53-5.28a.75.75 0 0 0-1.06 1.06l.353.354a.75.75 0 1 0 1.06-1.06zm12.504 0a.75.75 0 0 0-1.06 0l-.354.353a.75.75 0 0 0 1.06 1.06l.354-.353a.75.75 0 0 0 0-1.06", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-bulb-filled", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-bulb-filled"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-bulb-filled":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconBulbFilled$1);
            }
            break;
    } });
}

const CosmosIconBulbFilled = CosmosIconBulbFilled$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconBulbFilled, defineCustomElement };
